import React from 'react';
//import { FaFlag } from 'react-icons/fa';
import ReactCountryFlag from 'react-country-flag';
const FlagIcon = ({ countryCode }) => (
  <ReactCountryFlag countryCode={countryCode} />
);

export default FlagIcon;
